const ENRequirementsOccurrences = {
	"Alterar requisito de ocorrência": "Change occurrence requirement",
	"Deseja realmente excluir o requisito de ocorrência": "Do you really want to delete the occurrence requirement",
	"Erro ao adicionar requisito de ocorrência": "Error adding occurrence requirement",
	"Erro ao alterar requisito de ocorrência": "Error on changing occurrence requirement",
	"Erro ao excluir requisito de ocorrência": "Error on deleting occurrence requirement",
	"Exclusão de requisito de ocorrência": "Delete occurrence requirement",
	"Inserção de requisito de ocorrência": "Insert occurrence requirement",
	"Novo requisito": "New occurrence requirement",
	"Requisitos de Ocorrências": "Occurrence Requirements",
	"Requisito de ocorrência adicionado com sucesso": "Occurrence requirement successfully added",
	"Requisito de ocorrência alterado com sucesso": "Occurrence requirement successfully changed",
	"Requisito de ocorrência excluído com sucesso": "Occurrence requirement successfully deleted"
};

export default ENRequirementsOccurrences;

